import { useQuery, queryOptions } from '@tanstack/react-query'
import { BetAccount } from '@mobi/api-types'
import { useHostContext } from '@mobi/account/Common'
import { queryKeys } from '../Utils'
import { accountUrl, get } from '../Utils/network'

type UseBetAccountProps = {
  enabled?: boolean
}

const TWO_HOURS_IN_MS = 2 * 60 * 60 * 1000

export const betAccountQueryOptions = queryOptions({
  queryKey: [queryKeys.betAccount],
  queryFn: fetchBetAccount,
  refetchOnWindowFocus: false,
  gcTime: TWO_HOURS_IN_MS,
  staleTime: TWO_HOURS_IN_MS,
})

export function useBetAccount(options: UseBetAccountProps = {}) {
  const { logout } = useHostContext()
  const betAccountQuery = useQuery({
    ...betAccountQueryOptions,
    enabled: options.enabled ?? true,
  })

  if (betAccountQuery.data?.Status === 'Closed') logout?.()

  return betAccountQuery
}

export async function fetchBetAccount(): Promise<BetAccount> {
  return await get<BetAccount>(accountUrl.getBetAccountDetails)
}
